const BASE = import.meta.env.VITE_API_BASE_URL ?? '';

export interface Me {
  name: string;
  isAdmin: boolean;
}

/** Returns the signed-in user's name and whether they hold the Admin role. */
export async function fetchMe(accessToken: string): Promise<Me> {
  const res = await fetch(`${BASE}/api/me`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
  return res.json();
}
